var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('select',{staticClass:"select-css",domProps:{"value":_vm.selectedLabel},on:{"change":_vm.onChange}},_vm._l((_vm.options),function(option){return _c('option',{key:option.value,attrs:{"disabled":option.disabled}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }